import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/components/organisms/virtual-office/virtual-office.tsx")